import mesimoLogoMark from "../../../assets/logo/logo-watermark.png";

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-gray-950 border-t border-white/10 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-1 mb-4">
              <div className="w-11 h-11 flex items-center justify-center flex-shrink-0">
                <img
                  src={mesimoLogoMark}
                  alt="Mesimo Inc."
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="font-bold text-lg text-white tracking-tight">
                <span className="lowercase">m</span>esimo<span className="font-bold text-white/40">.inc</span>
              </span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs mb-2">
              <em className="text-white/60 not-italic font-medium">Turning Ideas Into Digital Reality.</em>
            </p>
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs mb-6">
              A tech company based in Takoradi, Ghana — building world-class software products, web apps, and digital solutions for ambitious businesses worldwide.
            </p>
            <div className="flex gap-3">
              {[
                { icon: "ri-instagram-line", href: "https://www.instagram.com/mesimo.inc" },
                // { icon: "ri-twitter-x-line", href: "https://twitter.com/mesimoinc" },
                // { icon: "ri-linkedin-line", href: "https://www.linkedin.com/company/mesimo-inc" },
                { icon: "ri-github-line", href: "https://github.com/Mesimo-Labs" },
              ].map((item) => (
                <a key={item.icon} href={item.href} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                  <i className={`${item.icon} text-white text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-5">Services</h4>
            <ul className="space-y-3">
              {["Custom Software", "Web Applications", "Mobile Apps", "Cloud & DevOps"].map((item) => (
                <li key={item}>
                  <a href="#" className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-5">Navigate</h4>
            <ul className="space-y-3">
              {[
                { label: "About", id: "hero" },
                { label: "Services", id: "about" },
                { label: "Work", id: "work" },
                { label: "Team", id: "team" },
                { label: "Testimonials", id: "testimonials" },
                { label: "Contact", id: "contact" },
              ].map((item) => (
                <li key={item.label}>
                  <button onClick={() => scrollTo(item.id)} className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer">
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-sm">© 2026 Mesimo Inc. All rights reserved.</p>
          {/* <div className="flex gap-6">
            {["Privacy Policy", "Terms of Service"].map((item) => (
              <a key={item} href="#" className="text-gray-600 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap">{item}</a>
            ))}
          </div> */}
        </div>
      </div>
    </footer>
  );
}
